var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading"
        }
      ],
      staticClass: "Edit"
    },
    [
      _c(
        "el-header",
        { staticClass: "Edit-header" },
        [
          _c("el-page-header", {
            attrs: { content: _vm.title },
            on: { back: _vm.close }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-main",
        { staticClass: "Edit-main" },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "100px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "广告主账号", prop: "userName" }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: _vm.isModel === 2 },
                    model: {
                      value: _vm.form.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "userName", $$v)
                      },
                      expression: "form.userName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "密码", prop: "passWord" }
                },
                [
                  _c("el-input", {
                    attrs: { "show-password": "" },
                    model: {
                      value: _vm.form.passWord,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "passWord", $$v)
                      },
                      expression: "form.passWord"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "姓名", prop: "nickName" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "nickName", $$v)
                      },
                      expression: "form.nickName"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "广告主", prop: "adowner" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { disabled: _vm.isModel === 2 },
                      model: {
                        value: _vm.form.adowner,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "adowner", $$v)
                        },
                        expression: "form.adowner"
                      }
                    },
                    _vm._l(_vm.adowner, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.advertiserName,
                          value: item.advertiserId
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "联系人", prop: "linkman" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.linkman,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "linkman", $$v)
                      },
                      expression: "form.linkman"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "联系电话", prop: "phone" }
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "phone", _vm._n($$v))
                      },
                      expression: "form.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "角色", prop: "roleId" } },
                [
                  _c(
                    "el-select",
                    {
                      model: {
                        value: _vm.form.roleId,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "roleId", $$v)
                        },
                        expression: "form.roleId"
                      }
                    },
                    _vm._l(_vm.role, function(item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.roleName, value: item.roleId }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  staticStyle: { width: "500px" },
                  attrs: { label: "备注", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("form")
                        }
                      }
                    },
                    [_vm._v("提交")]
                  ),
                  _vm._v(" "),
                  _vm.isModel !== 2
                    ? _c(
                        "el-button",
                        {
                          on: {
                            click: function($event) {
                              return _vm.resetForm("form")
                            }
                          }
                        },
                        [_vm._v("重置")]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f28c083c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f28c083c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ad_user/Edit.vue
// module id = ypj6
// module chunks = 1